<template lang="html">
  <div :is="tag">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    tag: {
      default: 'div',
    },
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/parts/components/item.vue